import { render, staticRenderFns } from "./ChiPhiKhac.vue?vue&type=template&id=6caeffbb&"
import script from "./ChiPhiKhac.vue?vue&type=script&lang=js&"
export * from "./ChiPhiKhac.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports